import { toDate } from "./toDate.js";

/**
 * The {@link isSaturday} function options.
 */

/**
 * @name isSaturday
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param date - The date to check
 * @param options - An object with options
 *
 * @returns The date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * const result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
export function isSaturday(date, options) {
  return toDate(date, options === null || options === void 0 ? void 0 : options.in).getDay() === 6;
}

// Fallback for modularized imports:
export default isSaturday;